import React from "react";
import { EditInput } from "@fidget/common/components/form/editInput";
import { InputGroup } from "@fidget/common/components/form/inputGroup";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { WithLocaleHeader } from "../settingsForms/WithLocaleHeader/WithLocaleHeader";
import { LanguageOption } from "@fidget/common/components/form/languagePicker/languagePicker";
import { InputsRow } from "../settingsForms/InputsRow/InputsRow";

interface LanguageProps {
  language: LanguageOption;
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  disabled?: boolean;
  errorHint?: string;
  placeholder: string;
}

export interface Props {
  languagesProps: LanguageProps[];
  maxLength?: number;
}

export const WelcomeMessages: React.SFC<Props> = ({ languagesProps, maxLength }) => (
  <InputsRow>
    {languagesProps.map((languageProps) => (
      <WithLocaleHeader key={languageProps.language} locale={languageProps.language}>
        <InputGroup>
          <EditInput
            value={languageProps.value}
            onChange={(ev) => languageProps.onChange((ev.target as HTMLInputElement).value)}
            className={commonStyles.input}
            placeholder={languageProps.placeholder}
            maxLength={maxLength}
            disabled={languageProps.disabled}
            hasError={languageProps.hasError}
            errorHint={languageProps.errorHint}
          />
        </InputGroup>
      </WithLocaleHeader>
    ))}
  </InputsRow>
);
